<template>
    <div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="payer_id">Payer Name <small class="text-muted"><em>(Optional)</em></small></label>
                <select id="payer_id" name="payer_id" v-bind:class="['custom-select', {'is-invalid' : hasError('payer_name') }]" v-model="payer.id" @change="changePayer" :disabled="readonly">
                    <option v-for="option in payers" :key="option.id" v-bind:value="option.id" v-text="option.name"></option>
                </select>
                <input type="hidden" name="payer_name" :value="payer.name">
                <span v-if="hasError('payer_name')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('payer_name')"></strong>
                </span>                           
            </div>
            <div class="form-group col-md-6">
                <label for="claim_number">Claim Number <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="claim_number" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('claim_number') }]" name="claim_number" v-model="payer.claim_number" :disabled="readonly">
                <span v-if="hasError('claim_number')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('claim_number')"></strong>
                </span>                
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-5">
                <label for="payer_address">Address <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="payer_address" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('payer_address') }]" name="payer_address" v-model="payer.address" :disabled="readonly">
                <span v-if="hasError('payer_address')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('payer_address')"></strong>
                </span>                
            </div>
            <div class="form-group col-md-3">
                <label for="payer_city">City <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="payer_city" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('payer_city') }]" name="payer_city" v-model="payer.city" :disabled="readonly">
                <span v-if="hasError('payer_city')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('payer_city')"></strong>
                </span>                
            </div>
            <div class="form-group col-md-2">
                <label for="payer_state">State <small class="text-muted"><em>(Optional)</em></small></label>
                <select id="payer_state" v-bind:class="['custom-select', {'is-invalid' : hasError('payer_state') }]" name="payer_state" v-model="payer.state" :disabled="readonly">
                    <option v-for="state in states" :key="state.code" :value="state.code" v-text="state.name"></option>
                </select>
                <span v-if="hasError('payer_state')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('payer_state')"></strong>
                </span>                  
            </div>
            <div class="form-group col-md-2">
                <label for="payer_postal_code">Postal Code <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="payer_postal_code" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('payer_postal_code') }]" name="payer_postal_code" v-model="payer.postal_code" :disabled="readonly">
                <span v-if="hasError('payer_postal_code')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('payer_postal_code')"></strong>
                </span>                 
            </div>                         
        </div>
        <div class="row">
            <div class="form-group col-md-4">
                <label for="payer_adjuster">Authorizations Adjuster <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="payer_adjuster" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('payer_adjuster') }]" name="payer_adjuster" list="contact-options" :value="payer.adjuster_name"  @input="onInput($event.target.value)" :disabled="readonly">
                <datalist id="contact-options">
                    <option v-for="contact in contacts" :key="contact.id" :value="contact.full_name" v-text="contact.full_name"></option>
                </datalist>                
                <span v-if="hasError('payer_adjuster')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('payer_adjuster')"></strong>
                </span>                
            </div>
            <div class="form-group col-md-4">
                <label for="payer_email">Email <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="payer_email" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('payer_email') }]" name="payer_email" v-model="payer.email" :disabled="readonly">
                <span v-if="hasError('payer_email')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('payer_email')"></strong>
                </span>                
            </div>            
            <div class="form-group col-md-2">
                <label for="payer_phone">Phone <small class="text-muted"><em>(Optional)</em></small></label>
                <div class="input-group">
                    <telephone-input id="payer_phone" v-bind:class="['form-control', {'is-invalid' : hasError('payer_phone') }]" name="payer_phone" v-model="payer.phone" :disabled="readonly"></telephone-input>
                    <div class="input-group-append">
                        <span class="input-group-text fas fa-phone pt-2"></span>
                    </div>
                    <span v-if="hasError('payer_phone')" class="invalid-feedback" role="alert">
                        <strong v-text="errorText('payer_phone')"></strong>
                    </span>                    
                </div>      
            </div>
            <div class="form-group col-md-2">
                <label for="payer_fax">Fax <small class="text-muted"><em>(Optional)</em></small></label>
                <div class="input-group">
                    <telephone-input id="payer_fax" v-bind:class="['form-control', {'is-invalid' : hasError('payer_fax') }]" name="payer_fax" v-model="payer.fax" :disabled="readonly"></telephone-input>
                    <div class="input-group-append">
                        <span class="input-group-text fas fa-fax pt-2"></span>
                    </div>
                    <span v-if="hasError('payer_fax')" class="invalid-feedback" role="alert">
                        <strong v-text="errorText('payer_fax')"></strong>
                    </span>              
                </div>
            </div>            
        </div>
        <div class="row">
            <div class="custom-control custom-checkbox ml-3 my-2">
                <input id="claims-adjuster-checkbox" type="checkbox" class="custom-control-input" v-model="adjusterChecked" @change="onChange($event)">
                <label class="custom-control-label align-top" for="claims-adjuster-checkbox">
                    Health insurance claim forms adjuster and/or fax number is different from requests for authorizations.
                </label>
            </div>
        </div>
        <div v-if="adjusterChecked" class="row">
            <div class="form-group col-md-4">
                <label for="claims_adjuster_name">Claims Adjuster <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="claims_adjuster_name" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('claims_adjuster_name') }]" name="claims_adjuster_name" list="claims-adjuster-contact-options" :value="payer.claims_adjuster_name"  @input="onClaimsAdjusterInput($event.target.value)" :disabled="readonly">
                <datalist id="claims-adjuster-contact-options">
                    <option v-for="contact in contacts" :key="'claims-adjuster-contact-' + contact.id" :value="contact.full_name" v-text="contact.full_name"></option>
                </datalist>                
                <span v-if="hasError('claims_adjuster_name')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('claims_adjuster_name')"></strong>
                </span>                
            </div>
            <div class="form-group col-md-4">
                <label for="claims_adjuster_email">Email <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="claims_adjuster_email" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('claims_adjusteremail') }]" name="claims_adjuster_email" v-model="payer.claims_adjuster_email" :disabled="readonly">
                <span v-if="hasError('claims_adjuster_email')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('claims_adjuster_email')"></strong>
                </span>                
            </div>            
            <div class="form-group col-md-2">
                <label for="claims_adjuster_phone">Phone <small class="text-muted"><em>(Optional)</em></small></label>
                <div class="input-group">
                    <telephone-input id="claims_adjuster_phone" v-bind:class="['form-control', {'is-invalid' : hasError('claims_adjuster_phone') }]" name="claims_adjuster_phone" v-model="payer.claims_adjuster_phone" :disabled="readonly"></telephone-input>
                    <div class="input-group-append">
                        <span class="input-group-text fas fa-phone pt-2"></span>
                    </div>
                    <span v-if="hasError('claims_adjuster_phone')" class="invalid-feedback" role="alert">
                        <strong v-text="errorText('claims_adjuster_phone')"></strong>
                    </span>                    
                </div>      
            </div>
            <div class="form-group col-md-2">
                <label for="claims_adjuster_fax">Fax <small class="text-muted"><em>(Optional)</em></small></label>
                <div class="input-group">
                    <telephone-input id="claims_adjuster_fax" v-bind:class="['form-control', {'is-invalid' : hasError('claims_adjuster_fax') }]" name="claims_adjuster_fax" v-model="payer.claims_adjuster_fax" :disabled="readonly"></telephone-input>
                    <div class="input-group-append">
                        <span class="input-group-text fas fa-fax pt-2"></span>
                    </div>
                    <span v-if="hasError('claims_adjuster_fax')" class="invalid-feedback" role="alert">
                        <strong v-text="errorText('claims_adjuster_fax')"></strong>
                    </span>              
                </div>
            </div>            
        </div>                 
    </div>
</template>

<script>
export default {
    props: {
        payers: Array,
        model: Object,
        errors: Object,
        readonly: Boolean,
        states: Array,
        contacts: Array,
    },
    data() {
        return {
            payer: this.model,
            adjusterChecked: false
        }
    },
    computed: {
        checked: function () {
            return !!(this.payer.claims_adjuster_name || this.payer.claims_adjuster_email || this.payer.claims_adjuster_phone || this.payer.claims_adjuster_fax);
        }
    },  
    methods: {
        changePayer: function () {
            var self = this;
            let selected = self.payers.find(function (element) {
                return element.id == self.payer.id;
            });

            if (selected) {
                self.payer.name = selected.name;
                self.payer.address = selected.address;
                self.payer.city = selected.city;
                self.payer.state = selected.state;
                self.payer.postal_code = selected.postal_code;
                self.payer.phone = selected.phone;
                self.payer.fax = selected.fax;
            }
        },
        hasError: function (name) {
            return this.errors.hasOwnProperty(name);
        },
        errorText: function (name) {
            return this.errors[name][0];
        },
        onInput: function (value) {
            let contact = this.contacts.find( (o) => { return o.full_name.toUpperCase() === value.toUpperCase(); });
            if (contact) {
                this.payer.adjuster_name = contact.full_name;
                this.payer.phone = contact.telephone;
                // this.payer.fax = contact.fax;    // TODO: set fax from contact or payer?
                this.payer.email = contact.email;
            }
            else {
                this.payer.adjuster_name = value;
            }
        },
        onClaimsAdjusterInput: function (value) {
            let contact = this.contacts.find( (o) => { return o.full_name.toUpperCase() === value.toUpperCase(); });
            if (contact) {
                this.payer.claims_adjuster_name = contact.full_name;
                this.payer.claims_adjuster_email = contact.email;
                this.payer.claims_adjuster_phone = contact.telephone;
                this.payer.claims_adjuster_fax = contact.fax;
            }
            else {
                this.payer.claims_adjuster_name = value;
            }
        },        
        onChange: function (e) {
            this.adjusterChecked = this.checked || e.target.checked;
            e.target.checked = this.adjusterChecked;
        }        
    },
    created() {
        this.adjusterChecked = this.checked;
    }
}
</script>

<style>
    .instructions-icon {
        font-size: .60em;
        font-weight: bold;
        color: #6c757d;
    }

    .instructions {
        font-size: .90em;
        font-style: italic;
        font-weight: bold;
        color: #6c757d;
        position: relative;
        top: 2px;
    }
</style>